<template>
    <!-- 목록의 pin 번호 칸에서 여는 주문의 상품권 목록. 주문 상세와 같은 상품권 표를 쓰고, 제목줄에서 PIN 전체를 복사한다. -->
    <v-dialog v-model="shows" width="960" scrollable :fullscreen="$vuetify.breakpoint.mobile">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-card light class="d-flex flex-column" :tile="$vuetify.breakpoint.mobile">
            <v-card-title>
                상품권
                <span class="ml-2 body-2 grey--text">{{ order.orderNo || "-" }} · {{ pins.length }}장 · 충전완료 {{ gainedCount }} / 미충전 {{ pins.length - gainedCount }}</span>
                <v-spacer />
                <v-btn small color="primary" class="mr-4" :disabled="!pins.length" @click="copy"> {{ copied ? "복사됨" : "PIN 전체 복사" }} </v-btn>
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="pt-4" style="flex: 1 1 auto; min-height: 0; overflow-y: auto">
                <!-- 위에 다른 정보가 없으므로 표 높이 상한은 창 높이(90vh)에서 제목줄·여백만 뺀 값이다. -->
                <nshop-order-view-pins v-bind="{ order }" :label="false" max-height="calc(90vh - 120px)" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import NshopOrderViewPins from "./nshop-order-view-pins.vue";

export default {
    components: {
        NshopOrderViewPins,
    },
    props: {
        order: { type: Object, default: () => ({}) },
    },
    data: () => ({
        shows: false,
        copied: false,
    }),
    computed: {
        pins() {
            return this.order?.pins || [];
        },
        gainedCount() {
            return this.pins.filter((pin) => pin?.isGained).length;
        },
    },
    methods: {
        // PIN 을 한 줄에 하나씩 이어 클립보드에 넣는다. 성공하면 버튼 문구를 잠시 '복사됨' 으로 바꾼다.
        async copy() {
            try {
                await navigator.clipboard.writeText(this.pins.map((pin) => pin?.pno).join("\n"));
                this.copied = true;
                setTimeout(() => (this.copied = false), 2000);
            } catch (error) {
                console.error(error);
                alert("복사하지 못했습니다. 브라우저의 클립보드 권한을 확인해 주세요.");
            }
        },
    },
};
</script>
